import { ButtonList } from '@dixa/lib-shared-habla';
import cx from 'classnames';
import { useAtomValue } from 'jotai';
import { useModal } from 'lib-knowledge-modal';
import { routeGenerator } from 'lib-knowledge-utils/routes';
import { collectionIdAtom } from 'models/collectionStore';
import { useNavigate } from 'react-router-dom';

// TODO: importing styles from so far away is dangerous as you could change it without knowing it's used here
// Create a shared component for this, with the used styles
import styles from '../../components/editDeleteDropdown/dropdownContext.module.scss';
import { ArticleDeleteModal } from '../modals/articleDeleteModal';
import { ArticleMoveModal } from '../modals/articleMoveModal';

type ArticleMenuProps = {
  articleId: string;
  isSyncedWithElevio: boolean;
};
function ArticleMenu({
  articleId,
  isSyncedWithElevio,
}: ArticleMenuProps): JSX.Element {
  const collectionId = useAtomValue(collectionIdAtom);
  const { showModal } = useModal();
  const navigate = useNavigate();

  return (
    <>
      <ButtonList>
        <ButtonList.Item
          icon="pen"
          onClick={() =>
            navigate(
              routeGenerator.articleEdit({
                articleId,
                collectionId,
              }),
            )
          }
        >
          Edit article
        </ButtonList.Item>
        {!isSyncedWithElevio && (
          <>
            <ButtonList.Item
              icon="arrow-right"
              isDisabled={!collectionId}
              onClick={() =>
                showModal(ArticleMoveModal, { articleId, collectionId })
              }
            >
              Move article
            </ButtonList.Item>

            <ButtonList.Item
              icon="trash"
              className={cx(styles.buttonListItem, styles.deleteItem)}
              onClick={() => showModal(ArticleDeleteModal, { articleId })}
            >
              Delete article
            </ButtonList.Item>
          </>
        )}
      </ButtonList>
    </>
  );
}

export default ArticleMenu;
